export default {
  // Title
  title: "Tip",

  // Message
  trialExpiredMessage:
    "Dear user, your trial version has expired. Please contact customer service to purchase the paid version to continue using.",

  // Customer Service Label
  wechatCustomerService: "WeChat Customer Service",
};
